import { Attr, BelongsTo, Model } from "spraypaint";

import type { Chart } from "shared/modules/Charts/types/chartTypes";
import { ApplicationRecord } from "shared/services/spraypaint";

import type InsightsReport from "./InsightsReport";

@Model()
class InsightsReportKeyInsight extends ApplicationRecord {
  static jsonapiType = "insights_report_key_insights";

  @Attr() chart: Chart;

  @BelongsTo() insightsReport: InsightsReport;

  @Attr() position: number;

  @Attr() primaryValue: number;

  @Attr() secondaryValue: number;
}

export default InsightsReportKeyInsight;
